import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class GoalService {
    private goalKey = 'selectedGoal'

    constructor() { }

    saveGoal(goal: string) {
        localStorage.setItem(this.goalKey, goal)
    }

    getGoal(): string | null {
        return localStorage.getItem(this.goalKey)
    }
}